import $ from 'jquery';
import { FireComponent } from '@base';

export class Paragraph extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {};
  }

  _sortableTable() {
    if (this.$component.find('.bux-table--sortable').length) {
      const sortableTables = this.$component.find('.bux-table--sortable');
      Array.from(sortableTables).forEach((table) => {
        const thCells = table.querySelectorAll('thead > tr > th');
        /**
				<th scope="col" class="sort-by">
					<button aria-pressed="false">Column 1</button>
				</th>
				 */
        thCells.forEach((cell, index) => {
          const cellCopy = cell.innerHTML;
          const button = document.createElement('button');
          button.setAttribute('aria-pressed', 'false');
          button.innerHTML = cellCopy;
          cell.classList.add('sort-by');
          cell.innerHTML = '';
          cell.appendChild(button);

          button.addEventListener('click', function () {
            var t = button.parentElement;
            sortTable(t.parentElement.parentElement.parentElement, Array.prototype.indexOf.call(t.parentElement.children, t), !t.classList.contains('th-sort-asc'));
          });
        });

        const div = document.createElement('div');
        div.classList.add('bux-table');
        div.classList.add('bux-table--sortable');
        div.classList.add('bux-table--announcement-region');
        div.setAttribute('aria-live', 'polite');
        table.appendChild(div);
      });
    }
  }

  init() {
    if (this.componentExists) {
      this._sortableTable();
    }
  }
}
